module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_03-450-630903b0ac0f499fe475fcac1073c0eb.png";